<template>
    <main>
        <section v-if="!error">
            <div class="smallContainer">
                <div>
                    <strong>{{ author }}</strong> has invited you to play in
                </div>
                <h1>{{ title }}</h1>
                <div>
                    <button @click="joinCampaign">Accept</button>
                    <router-link :to="{ name: 'campaign-list' }" tag="button">Decline</router-link>
                </div>
            </div>
        </section>
        <section v-if="error">
            {{ error }}
        </section>
    </main>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            campaignId: '',
            author: '',
            title: '',
            error: '',
        };
    },
    ...mapGetters(['oidcUser']),
    beforeRouteEnter(to, from, next) {
        axios
            .get(`/api/campaigns/${to.params.id}`)
            .then(response => {
                next(vm => vm.setData(response.data));
            })
            .catch(error => {
                next(vm => vm.setError(error));
            });
    },
    methods: {
        setData(data) {
            this.author = data.owner;
            this.title = data.name;
            this.campaignId = data.id;
        },
        setError(/*error*/) {
            this.error = 'Error loading campaign invitation.';
        },
        joinCampaign() {
            axios.put(`/api/campaigns/${this.campaignId}/join`).then(() => this.$router.push('/'));
        },
    },
};
</script>

<style scoped>
section div,
h1 {
    margin: 30px;
    padding: 0;
    color: white;
}

section .smallContainer {
    background-color: darkblue;
    width: 500px;
    text-align: center;
    margin-left: 30px;
    padding: 20px;
    border-radius: 10px;
}

div button {
    margin: 10px;
    padding: 10px;
}
</style>
